<ui-breadcrumbs *ngIf="breadcrumbs?.length" [items]="breadcrumbs"></ui-breadcrumbs>
<ui-page-header-headless
  [text]="text"
  [isMobile]="isMobile"
  [showRefreshButton]="showRefreshButton"
  [showDivider]="showDivider"
  [isLoading]="isLoading"
  [useH1Tag]="useH1Tag"
  (refresh)="refresh.emit()"
>
  <ng-content></ng-content>
</ui-page-header-headless>
